import { Box, Flex, Text } from '@chakra-ui/react';

interface UserMessageProps {
  content: string;
}

export function UserMessage({ content }: UserMessageProps) {
  return (
    <Flex justify="flex-end" mb={4}>
      <Box
        bg="gray.100"
        borderRadius="lg"
        px={4}
        py={2}
        maxW="80%"
        wordBreak="break-word"
      >
        <Text fontSize="sm" color="gray.800">
          {content}
        </Text>
      </Box>
    </Flex>
  );
}
